package addedittravelagent

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.file.ui.FileState
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.travelagent.domain.model.TravelAgentModel

data class AddEditTravelAgentState(
    val travelAgent: MutableState<TravelAgentModel> = mutableStateOf(TravelAgentModel.empty),
    val fileState: FileState = FileState(),
    val getTravelAgent: State<TravelAgentModel> = State(),
    val addEditTravelAgent: State<TravelAgentModel> = State(),
    val getRequests: State<List<RequestModel>> = State(),
    val getProposals: State<List<ProposalModel>> = State(),
    val getItineraries: State<List<ItineraryModel>> = State(),
    val isEditEnabled: Boolean = false,
)
